import { useMemo } from 'react';

import { ContactName } from '../../templates';
import { getDefaultColumns } from './defaultColumns';
import { buildDynamicColumns } from '../../components';
import type { MonitoringColumns } from './useCampaignMonitoring';

const attachMessagesLinkSuffix = (
  column: DynamicColumnType
): DynamicColumnType => {
  if (!column.fields?.length) return column;

  const [firstField, ...fields] = column.fields;

  return {
    ...column,
    fields: [
      {
        ...firstField,
        style: { ...firstField.style, display: 'flex' },
        renderSuffix: (_v, data) => {
          return ContactName.renderMessagesLink(data.contact_id);
        },
      },
      ...fields,
    ],
  };
};

const preProcessCustomColumns = (
  dataColumns: DynamicColumnType[] | undefined
): DynamicColumnType[] => {
  if (!dataColumns) return [];

  return dataColumns.map(column => {
    if (column.key === 'contact_info' && column.type === 'composite') {
      return attachMessagesLinkSuffix(column);
    }

    return column;
  });
};

export const useCampaignColumns = (
  id: string,
  dataColumns: MonitoringColumns | undefined,
  statesMap: Record<any, any>
) => {
  const result = useMemo(() => {
    const initial = getDefaultColumns(id, statesMap);
    const customKeysSet = new Set((dataColumns || []).map(c => c.key) || []);

    const defaultColumns = Object.entries(initial)
      .filter(([key]) => !customKeysSet.has(key))
      .map(([_key, value]) => value);
    const columns = buildDynamicColumns(preProcessCustomColumns(dataColumns));

    return [...columns, ...defaultColumns];
  }, [id, dataColumns, statesMap]);

  return result;
};
